import SectionHeading from '@/components/base/SectionHeading';
import { hotRanking } from '@/mocks/home';

const formatHeat = (value: number) => (value >= 10000 ? `${(value / 10000).toFixed(1)}万` : `${value}`);

const rankStyle = (rank: number) => {
  if (rank === 1) return 'bg-primary-500 text-background-50';
  if (rank === 2) return 'bg-accent-500 text-background-50';
  if (rank === 3) return 'bg-secondary-500 text-foreground-950';
  return 'bg-background-100 text-foreground-600';
};

const deltaMap: Record<string, { icon: string; className: string }> = {
  up: { icon: 'ri-arrow-up-line', className: 'text-primary-600' },
  down: { icon: 'ri-arrow-down-line', className: 'text-accent-600' },
  flat: { icon: 'ri-subtract-line', className: 'text-foreground-400' },
};

export default function HotRanking() {
  return (
    <section id="ranking" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="w-full max-w-[1180px] mx-auto">
        <SectionHeading
          eyebrow="Hot Ranking"
          icon="ri-fire-line"
          title="全站热度榜：当前讨论最集中的 10 条"
          desc="综合检索量、讨论量与会话停留时长加权得出，每 30 分钟重算一次。榜单只收录已确认归属板块的内容。"
        />

        <div className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
          <div className="flex items-center justify-between gap-4 px-4 md:px-6 py-4 border-b border-background-200 bg-background-50">
            <span className="text-xs md:text-sm text-foreground-600">
              <i className="ri-refresh-line mr-1.5"></i>
              数据截至 今日 10:30 · 30 分钟自动重算
            </span>
            <span className="hidden sm:flex items-center gap-4 text-xs text-foreground-500">
              <span>热度</span>
              <span>趋势</span>
            </span>
          </div>

          <ol className="grid grid-cols-1 md:grid-cols-2">
            {hotRanking.map((item, index) => {
              const rank = index + 1;
              const delta = deltaMap[item.delta] ?? deltaMap.flat;
              return (
                <li
                  key={item.id}
                  className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 border-b border-background-200 md:[&:nth-child(odd)]:border-r"
                >
                  <span
                    className={`w-8 h-8 shrink-0 flex items-center justify-center rounded-md font-heading font-bold text-sm ${rankStyle(rank)}`}
                  >
                    {rank}
                  </span>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2 mb-1.5">
                      <span className="px-2 py-0.5 rounded bg-background-50 border border-background-300 text-[11px] text-foreground-600 whitespace-nowrap">
                        {item.board}
                      </span>
                    </div>
                    <p className="text-xs md:text-sm text-foreground-800 leading-snug line-clamp-2">
                      {item.title}
                    </p>
                  </div>
                  <div className="shrink-0 flex flex-col items-end gap-1">
                    <span className="font-heading text-sm md:text-base font-bold text-foreground-950 whitespace-nowrap">
                      {formatHeat(item.heat)}
                    </span>
                    <span className={`flex items-center gap-0.5 text-[11px] ${delta.className}`}>
                      <i className={delta.icon}></i>
                      {item.delta === 'up' ? '上涨' : item.delta === 'down' ? '回落' : '持平'}
                    </span>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}